import React, {useEffect} from "react";
import "./kamolac.css";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import KamoHeader from "./KamoHeader";
import KamolacFooter from "./KamolacFooter";

const Puwoodfinish = () => {

     useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
    <KamoHeader />
      <div className="ultra">

      {/* HERO */}
      <section className="hero">
        <div className="overlay"></div>
        <div className="hero-content">
          <h1>Don’t Just Paint.</h1>
          <h2>Protect & Perfect.</h2>
          <p>
            Whether you are looking for the understated elegance of a Lovely home or the high-octane mirror shine of a luxury showroom, our PU (Polyurethane) Wood Finishes offer the ultimate protection and aesthetic for your timber surfaces.
          </p>
        </div>
      </section>

      {/* WHY */}
      <section className="section glass">
        <h3>Why Choose PU Wood Finishes?</h3>
        <p>
          Polyurethane is the gold standard for interior wood coating. It provides a durable, non-yellowing, and scratch-resistant layer that preserves the natural beauty of wood while shielding it from moisture, heat, and daily wear-and-tear.
        </p>
      </section>

      {/* SPECTRUM */}
      <section className="section">
        <h3 className="title">Our Finish Spectrum</h3>
        <p style={{textAlign:'center', marginBottom:45}}>We offer three distinct levels of sheen to match your interior design vision:
</p>

        <div className="cards">

          <div className="card">
            <img src={process.env.PUBLIC_URL + '/images/products/new/4.jpeg'} alt="Kamdhenupaints" />
            <h4>Matt Finish: The Naturalist</h4>
            <p>For those who appreciate the raw, organic texture of wood without the glare.
</p>
            <p><b>Appearance:</b> Zero to low reflection. It highlights the grain pattern without adding artificial shine.</p>
            <p><b>Best For:</b> Modern minimalist furniture, Scandinavian designs, and high-traffic areas.</p>
            <p><b>Pro Tip:</b> This finish is excellent at hiding small scratches, dust, and fingerprints.</p>
          </div>

          <div className="card">
             <img src={process.env.PUBLIC_URL + '/images/products/new/3.png'} alt="Kamdhenupaints" />
            <h4> Semi-Gloss Finish: The Balanced Choice</h4>
            <p>The perfect middle ground between understated and opulent.
</p>
            <p><b>Appearance:</b> A soft, satin-like glow that reflects just enough light to add depth to the wood.</p>
            <p><b>Best For:</b> Kitchen cabinets, doors, and dining tables where you want a "clean" look that’s easy to maintain.</p>
            <p><b>Pro Tip:</b> Semi-gloss provides a smooth feel that is significantly easier to wipe down than a full matt finish.</p>
          </div>

          <div className="card">
           <img src={process.env.PUBLIC_URL + '/images/products/new/5.png'} alt="Kamdhenupaints" />
            <h4>Gloss Finish: The Showstopper</h4>
            <p>Designed for luxury, impact, and a high-definition "wet" look.
</p>
            <p><b>Appearance:</b> High reflectivity with a mirror-like depth. It makes colors appear richer and more vibrant.</p>
            <p><b>Best For:</b> Statement pieces, musical instruments, luxury executive desks, and ornate panelling.</p>
            <p><b>Pro Tip:</b> Gloss finishes are incredibly durable but do show fingerprints more easily—best used on surfaces meant to be admired.</p>
          </div>

        </div>
      </section>

 <section className="tp-section">

      <div className="tp-wrapper">

        {/* LEFT SIDE */}
        <div className="tp-left">
          <h2>Technical Performance</h2>
          <p className="tp-sub">
            Our PU coatings are engineered for longevity:
          </p>

          <div className="tp-cards">

            <div className="tp-card">
              <div className="icon">💧</div>
              <p>
                <strong>Resilience:</strong> High resistance to household chemicals and hot spills.
              </p>
            </div>

            <div className="tp-card">
              <div className="icon">✨</div>
              <p>
                <strong>Clarity:</strong> Crystal clear film that doesn't cloud over time.
              </p>
            </div>

            <div className="tp-card">
              <div className="icon">🌿</div>
              <p>
                <strong>Elasticity:</strong> Our formula moves with the wood, preventing cracks during seasonal temperature shifts.
              </p>
            </div>

          </div>
        </div>

        {/* RIGHT SIDE CTA */}
        <div className="tp-right">
          <div className="tp-cta">
            <p>
              Transform Your Woodwork: Not sure which sheen suits your space? Our experts can help you match the finish to your lighting and wood species.
            </p>
            <button>Get Expert Advice</button>
          </div>
        </div>

      </div>

    </section>

   
    </div>
    <KamolacFooter />
    </>
  );
};

export default Puwoodfinish;